import React from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import ReferralOptions from '../ReferralsIndexContainer/ReferralOptions';
function ReferralTrigger(_ref) {
  var csrfToken = _ref.csrfToken,
    referralPath = _ref.referralPath,
    newReferralPath = _ref.newReferralPath,
    authCodeUrl = _ref.authCodeUrl,
    shareOnLinkedinUrl = _ref.shareOnLinkedinUrl,
    returnFromLinkedIn = _ref.returnFromLinkedIn,
    authStatus = _ref.authStatus,
    isConsultant = _ref.isConsultant,
    location = _ref.location,
    referredUserType = _ref.referredUserType;
  return /*#__PURE__*/React.createElement(ModalTrigger, {
    triggerText: "Refer Now",
    buttonStyles: "primary",
    idKey: "refer-trigger-modal-".concat(location.replace(/\s/g, '')),
    showFooter: false,
    biggerButton: true
  }, /*#__PURE__*/React.createElement(ReferralOptions, {
    csrfToken: csrfToken,
    referralPath: referralPath,
    newReferralPath: newReferralPath,
    authCodeUrl: authCodeUrl,
    shareOnLinkedinUrl: shareOnLinkedinUrl,
    returnFromLinkedIn: returnFromLinkedIn,
    authStatus: authStatus,
    isConsultant: isConsultant,
    addReferrals: function addReferrals() {},
    location: location,
    referredUserType: referredUserType
  }));
}
ReferralTrigger.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  returnFromLinkedIn: PropTypes.bool,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  isConsultant: PropTypes.bool,
  location: PropTypes.string.isRequired,
  referredUserType: PropTypes.string.isRequired
};
ReferralTrigger.defaultProps = {
  returnFromLinkedIn: false,
  authCodeUrl: null,
  authStatus: null,
  isConsultant: false
};
export default ReferralTrigger;